export const getQueryKey = (noteId: string): [string, string] => [
  'NOTE_REMINDERS',
  noteId,
];
